import { fromLegacyTimeZone } from '@bingads-webui-universal/time-zone-converter';
import { findSelectedNode } from '@bingads-webui-react/with-site-map';
import { getCanonicalCategoriesAndColumns } from '@bingads-webui-campaign/reports-v4-column-chooser';
import { ViewItem } from '@bingads-webui-campaign/reports-v4-component';
import { getDefaultTimeRange } from '../date-picker';
import { getDefaultMultiAccountSelectorInfo } from '../../helpers/account-selector-helper';
import { getDefaultSortingColumn } from '../../helpers/default-sorting-column-helper';
import { getDefaultFilters } from '../../helpers/default-filter-helper';
import { getInsertionOrderSelectorValue, isInsertionOrderReport } from '../../helpers/insertion-order-helper';

function getDefaultTaskItemType({ accountId, isInternalUser }) {
  const regularTaskItemType = accountId ?
    'ReportUIAccountTemplate' :
    'ReportUICustomerTemplate';
  const finalTaskItemType = isInternalUser ?
    'ReportUITemplate' :
    regularTaskItemType;

  return finalTaskItemType;
}

function getDefaultGridPagination({ reportType, permissions }) {
  return { RequestedPage: 1, RowsPerPage: isInsertionOrderReport({ reportType, permissions }) ? 200 : 20 };
}

function getDefaultInsertionOrderViewType({ reportType, permissions }) {
  return isInsertionOrderReport({ reportType, permissions }) ? ViewItem.Monthly : undefined;
}

export const emptySchedule = {
  AttachFileToEmail: false,
  EmailRecipients: [],
  Cron: '',
  StartTime: undefined,
  EndTime: undefined,
};

export const getDefaultReportParam = ({
  reportSchema, siteMap, history, serverContext, i18n, permissions,
}) => {
  const {
    uid: userIdFromUrl,
    cid: customerId,
    aid: accountId,
    ioid: ioidFromUrl,
  } = history.query;

  const userIdFromServer = serverContext.CurrentUser.Id;
  const userId = Number.isInteger(userIdFromUrl) ?
    userIdFromUrl :
    userIdFromServer;

  const accountTimeZone = serverContext.CurrentAccount.TimeZone;
  const isInternalUser = serverContext.Permissions.IsInternalUser;

  const renderType = 'Table';

  const selectedNode = findSelectedNode(siteMap);

  const { columns } = getCanonicalCategoriesAndColumns({
    columns: [],
    reportSchema,
    permissions,
    history,
  });
  const isAllTime = !!(isInsertionOrderReport({ reportType: reportSchema.ReportType, permissions }) && ioidFromUrl);

  const reportParam = {
    reportName: i18n.getString(selectedNode.name),
    reportType: reportSchema.ReportType,
    userId,
    customerId,
    dateRange: {
      key: getDefaultTimeRange(reportSchema.ReportAggregation.default, reportSchema, isAllTime),
    },
    filters: getDefaultFilters(reportSchema.ReportType),
    sortedColumn: getDefaultSortingColumn(reportSchema.ReportType),
    timeZone: accountId && accountTimeZone ?
      fromLegacyTimeZone(accountTimeZone) :
      'PacificTimeUSCanadaTijuana',
    Type: getDefaultTaskItemType({ accountId, isInternalUser }),
    columns,
    scopeSelector: getDefaultMultiAccountSelectorInfo(reportSchema, history),
    schedule: {
      AttachFileToEmail: false,
      EmailRecipients: [],
      Cron: '',
      StartTime: undefined,
      EndTime: undefined,
    },
    ClientApplicationType: 'ReportingUI',
    Format: 'Xlsx',
    IsDVS: false,
    LCID: serverContext.Omniture.Lcid,
    MaxRowCount: 0, // TODO: what's this?
    RenderType: renderType,
    ReportAggregation: reportSchema.ReportAggregation.default,
    ReportOptions: [
      'IncludeColumnHeaders',
      'IncludeReportFooter',
      'IncludeReportHeader',
    ],
    GridPagination: getDefaultGridPagination({ reportType: reportSchema.ReportType, permissions }),
    insertionOrderViewType: getDefaultInsertionOrderViewType({ reportType: reportSchema.ReportType, permissions }),
    insertionOrderSelectorValue: getInsertionOrderSelectorValue({ reportType: reportSchema.ReportType, permissions, ioidFromUrl }),
  };
  return reportParam;
}
